import React, { useRef, useState, useEffect, useContext } from "react";
import ReactDatePicker from "react-datepicker";

import { useField } from "@unform/core";
import { Asterisk, ChevronLeft, ChevronRight } from "lucide-react";
import { getMonth, getYear, subYears } from "date-fns";

// import 'react-datepicker/dist/react-datepicker.css';

export default function DatePicker({
  name,
  title,
  grow,
  defaultValue,
  shrink,
  workloadUpdateName = false,
  readOnly = false,
  type,
  isZipCode = false,
  onlyUpperCase = false,
  onlyLowerCase = false,
  onlyInt = false,
  onlyFloat = false,
  isPhoneNumber = false,
  InputContext = null,
  ...rest
}) {
  const datepickerRef = useRef(null);
  const { fieldName, registerField, error } = useField(name);
  const { disabled, required } = { ...rest };

  const [date, setDate] = useState(defaultValue || null);

  const { setSuccessfullyUpdated } = useContext(InputContext);

  const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  function createRangeArrayFrom(start, end) {
    const length = end - start + 1;
    return Array.from({ length: length }, (_, index) => start + index);
  }

  const years = createRangeArrayFrom(
    getYear(subYears(new Date(), 100)),
    getYear(new Date()) + 15
  );

  const CustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => (
    <div className="flex flex-row w-full justify-between items-center gap-2 px-2">
      {/* <button
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        className="p-2 hover:bg-gray-200"
      >
        <ChevronLeft size={14} />
      </button> */}
      <select
        className="flex-1 hover:bg-gray-200 p-2 text-center"
        value={getYear(date)}
        onChange={({ target: { value } }) => changeYear(+value)}
      >
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <select
        className="flex-1 hover:bg-gray-200 p-2 text-center"
        value={MONTHS[getMonth(date)]}
        onChange={({ target: { value } }) => changeMonth(MONTHS.indexOf(value))}
      >
        {MONTHS.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      {/* <button
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        className="p-2 hover:bg-gray-200"
      >
        <ChevronRight size={14} />
      </button> */}
    </div>
  );

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: datepickerRef.current,
      path: "props.selected",
      clearValue: (ref) => {
        ref.clear();
      },
    });
  }, [fieldName, registerField]);

  function handleOnChange(date) {
    setDate(date);
    setSuccessfullyUpdated(false);
  }

  const width = shrink ? "w-32" : "w-full md:w-auto";
  return (
    <div
      className={`${
        type === "hidden" ? "hidden" : "flex"
      } flex-col justify-center items-start relative ${width} ${
        grow ? "grow" : ""
      }`}
    >
      <div className="px-2 text-xs flex flex-row justify-between items-center">
        {title} {required && <Asterisk color="#e00" size={12} />}
      </div>
      <div
        htmlFor={name}
        className={`w-full border rounded-xs p-2 px-4 text-sm flex flex-row justify-between items-center gap-2 ${
          (disabled || readOnly) && "bg-slate-100"
        } ${error && "border-red-300"}`}
      >
        <ReactDatePicker
          ref={datepickerRef}
          selected={date}
          disabled={disabled || readOnly}
          renderCustomHeader={CustomHeader}
          className={`bg-transparent w-full ${
            disabled || readOnly ? "text-black" : ""
          } `}
          onChange={handleOnChange}
          {...rest}
        />
      </div>
    </div>
  );
}
